import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/home'
import Index from '@/view/firstindex'
import Partner from '@/view/partner'
import Product from '@/view/product'
import Aboutus from '@/view/aboutus'

Vue.use(Router)

export default new Router({
  mode: 'history',//history
  base:'/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect:'/',
      children: [
        { path: '/', name: 'Index', component: Index },
        { path: 'partner', name: 'Partner', component: Partner },
        { path: 'product', name: 'Product', component: Product },
        { path: 'aboutus', name: 'Aboutus', component: Aboutus }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js